import { getLocalStorageObject, setLocalStorageObject } from '@xyo-network/sdk-xyo-react-js';
import AddressDetails from './AddressDetails';
class AddressInfo {
    constructor() {
        this.data = {};
        this.load();
    }
    getData() {
        return this.data;
    }
    getSanitizedData() {
        return this.data;
    }
    getBilling() {
        if (this.data.billing) {
            return new AddressDetails(this.data.billing, 'Billing');
        }
    }
    getBillingData() {
        return this.data.billing;
    }
    setBilling(address) {
        this.data.billing = address;
        this.save();
    }
    getShipping() {
        if (this.data.shipping) {
            return new AddressDetails(this.data.shipping, 'Shipping');
        }
    }
    getShippingData() {
        return this.data.shipping;
    }
    setShipping(address) {
        this.data.shipping = address;
        this.save();
    }
    save() {
        setLocalStorageObject('addressInfo', this.data);
    }
    load() {
        this.data = getLocalStorageObject('addressInfo');
    }
    clear() {
        localStorage.removeItem('addressInfo');
        this.data = {};
    }
    getSameAddress() {
        var _a;
        return (_a = this.data.sameAddress) !== null && _a !== void 0 ? _a : true;
    }
    setSameAddress(value) {
        this.data.sameAddress = value;
        if (value) {
            this.data.shipping = undefined;
        }
        this.save();
    }
    valid() {
        return this.errors().length === 0;
    }
    errors() {
        var _a, _b, _c, _d;
        let result = (_b = (_a = this.getBilling()) === null || _a === void 0 ? void 0 : _a.errors()) !== null && _b !== void 0 ? _b : [Error('Billing address missing')];
        if (!this.getSameAddress()) {
            result = result.concat((_d = (_c = this.getShipping()) === null || _c === void 0 ? void 0 : _c.errors()) !== null && _d !== void 0 ? _d : [Error('Shipping address missing')]);
        }
        return result;
    }
    static get() {
        var _a;
        this.instance = (_a = this.instance) !== null && _a !== void 0 ? _a : new AddressInfo();
        return this.instance;
    }
}
export default AddressInfo;
